import * as ContactMeta from './ContactMeta.jsx';
import { Blocks as LineItemCellBlocks } from '../common/LineItemCell.jsx';
import { ContainerTypeConfig as LineItemCellTypeConfig, MetaTokens as LineItemCellMetaTokens } from './LineItemCell.jsx';
import * as LineItems from './LineItems.jsx';
import * as MetaDate from '../common/MetaDate.jsx';
import * as MetaNotes from '../common/MetaNotes.jsx';
import * as MetaNumber from './MetaNumber.jsx';
import * as MetaStaff from '../common/MetaStaff.jsx';
import * as MetaTaxLine from './MetaTaxLine.jsx';
import Name from '../utility/Name.jsx';
import { Blocks as PaymentCreditCellBlocks, TypeConfig as PaymentCreditCellTypeConfig } from './PaymentCreditCell.jsx';
import { Tokens as PaymentCreditCellMetaTokens } from './PaymentCreditCellMeta.jsx';
import * as Payments from './Payments.jsx';
import * as Signature from './Signature.jsx';
import * as TotalsBalance from './TotalsBalance.jsx';
import * as TotalsDiscount from '../common/TotalsDiscount.jsx';
import * as TotalsGrandTotal from '../common/TotalsGrandTotal.jsx';
import * as TotalsPaid from './TotalsPaid.jsx';
import * as TotalsPromoCodes from './TotalsPromoCodes.jsx';
import * as TotalsRefunded from './TotalsRefunded.jsx';
import * as TotalsShipping from '../common/TotalsShipping.jsx';
import * as TotalsSubtotal from '../common/TotalsSubtotal.jsx';
import * as TotalsTaxes from '../common/TotalsTaxes.jsx';

const Blocks = {
    get: (group, data) => [
        {
            id: 'metaSeparator',
            dataType: 'separator',
            display: 'Meta',
            group
        },
        {
            id: Name.Block.Client.ContactMeta,
            component: ContactMeta.Component,
            config: {
                Block: ContactMeta.TypeConfig.panel.block(true),
                Style: ContactMeta.TypeConfig.panel.style()
            },
            display: 'Contact Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.Number,
            component: MetaNumber.Component,
            config: {
                Block: MetaNumber.TypeConfig.panel.block(),
                Style: MetaNumber.TypeConfig.panel.style(),
                Description: MetaNumber.TypeConfig.panel.description(),
                Label: MetaNumber.TypeConfig.panel.label('Invoice #'),
                Value: MetaNumber.TypeConfig.panel.value()
            },
            display: 'Invoice Number',
            group,
            image: ''
        },
        {
            id: Name.Block.TaxLine,
            component: MetaTaxLine.Component,
            config: {
                Block: MetaTaxLine.TypeConfig.panel.block(),
                Style: MetaTaxLine.TypeConfig.panel.style()
            },
            display: 'GST Tax Line',
            group,
            image: ''
        },
        {
            id: Name.Block.Date,
            component: MetaDate.Component,
            config: {
                Block: MetaDate.TypeConfig.panel.block(),
                Style: MetaDate.TypeConfig.panel.style(),
                Description: MetaDate.TypeConfig.panel.description(),
                Label: MetaDate.TypeConfig.panel.label('Invoice Date: '),
                Value: MetaDate.TypeConfig.panel.value()
            },
            display: 'Invoice Date',
            group,
            image: ''
        },
        {
            id: Name.Block.Company.StaffName,
            component: MetaStaff.Component,
            config: {
                Block: MetaStaff.TypeConfig.panel.block(),
                Style: MetaStaff.TypeConfig.panel.style(),
                Description: MetaStaff.TypeConfig.panel.description(),
                Label: MetaStaff.TypeConfig.panel.label(),
                Value: MetaStaff.TypeConfig.panel.value(),
                Visibility: MetaStaff.TypeConfig.panel.visibility()
            },
            display: 'User Name',
            group,
            image: ''
        },
        {
            id: Name.Block.Notes,
            component: MetaNotes.Component,
            config: {
                Block: MetaNotes.TypeConfig.panel.block(),
                Style: MetaNotes.TypeConfig.panel.style(),
                Description: MetaNotes.TypeConfig.panel.description(),
                Label: MetaNotes.TypeConfig.panel.label('Invoice Comments'),
                Value: MetaNotes.TypeConfig.panel.value(),
                Visibility: MetaNotes.TypeConfig.panel.visibility('Invoice Notes')
            },
            display: 'Invoice Notes',
            group,
            image: ''
        },
        {
            id: Name.Block.Signature,
            component: Signature.Component,
            config: {
                Block: Signature.TypeConfig.panel.block(),
                Style: Signature.TypeConfig.panel.style(),
                Description: Signature.TypeConfig.panel.description(),
                Label: Signature.TypeConfig.panel.label(),
                Value: Signature.TypeConfig.panel.value()
            },
            display: 'Signature Line',
            group,
            image: ''
        },
        {
            id: 'tablesSeparator',
            dataType: 'separator',
            display: 'Tables',
            group
        },
        {
            id: Name.Block.Inventory.List,
            component: LineItems.Component,
            config: {
                Block: LineItems.TypeConfig.panel.block(),
                Style: LineItems.TypeConfig.panel.style(),
                Visibility: LineItems.TypeConfig.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: LineItemCellTypeConfig.defaultDesign(data) }
                ]
            },
            display: 'Line Items',
            group,
            image: ''
        },
        {
            id: Name.Block.PaymentCredit.PaymentsContainer,
            component: Payments.PaymentsTable,
            config: {
                Block: Payments.PaymentsTypeConfig.panel.block(),
                Style: Payments.PaymentsTypeConfig.panel.style(),
                Header: Payments.PaymentsTypeConfig.panel.header(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: PaymentCreditCellTypeConfig.defaultDesign(Name.Content.PaymentLineItem, data) }
                ]
            },
            display: 'Payments Table',
            group,
            image: ''
        },
        {
            id: Name.Block.PaymentCredit.CreditsContainer,
            component: Payments.CreditsTable,
            config: {
                Block: Payments.CreditsTypeConfig.panel.block(),
                Style: Payments.CreditsTypeConfig.panel.style(),
                Header: Payments.CreditsTypeConfig.panel.header(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: PaymentCreditCellTypeConfig.defaultDesign(Name.Content.CreditLineItem, data) }
                ]
            },
            display: 'Credits Table',
            group,
            image: ''
        },
        {
            id: 'totalsSeparator',
            dataType: 'separator',
            display: 'Totals',
            group
        },
        {
            id: 'subtotal',
            component: TotalsSubtotal.Component,
            config: {
                Block: TotalsSubtotal.TypeConfig.panel.block(),
                Style: TotalsSubtotal.TypeConfig.panel.style(),
                Description: TotalsSubtotal.TypeConfig.panel.description(),
                Label: TotalsSubtotal.TypeConfig.panel.label(),
                Value: TotalsSubtotal.TypeConfig.panel.value(data)
            },
            display: 'Subtotal',
            group,
            image: ''
        },
        {
            id: Name.Block.Total.Discount,
            component: TotalsDiscount.Component,
            config: {
                Block: TotalsDiscount.TypeConfig.panel.block(),
                Style: TotalsDiscount.TypeConfig.panel.style(),
                Description: TotalsDiscount.TypeConfig.panel.description(),
                Label: TotalsDiscount.TypeConfig.panel.label(),
                Value: TotalsDiscount.TypeConfig.panel.value(data)
            },
            display: 'Discount',
            group,
            image: ''
        },
        {
            id: Name.Block.Total.PromoCodes,
            component: TotalsPromoCodes.Component,
            config: {
                Block: TotalsPromoCodes.TypeConfig.panel.block(),
                Style: TotalsPromoCodes.TypeConfig.panel.style(),
                Description: TotalsPromoCodes.TypeConfig.panel.description(),
                Label: TotalsPromoCodes.TypeConfig.panel.label(),
                Value: TotalsPromoCodes.TypeConfig.panel.value(data)
            },
            display: 'Promo Codes',
            group,
            image: ''
        },
        {
            id: 'taxes',
            component: TotalsTaxes.Component,
            config: {
                Block: TotalsTaxes.TypeConfig.panel.block(),
                Style: TotalsTaxes.TypeConfig.panel.style(),
                Description: TotalsTaxes.TypeConfig.panel.description(),
                Label: TotalsTaxes.TypeConfig.panel.label(),
                Value: TotalsTaxes.TypeConfig.panel.value(data)
            },
            display: 'Taxes',
            group,
            image: ''
        },
        {
            id: 'shipping',
            component: TotalsShipping.Component,
            config: {
                Block: TotalsShipping.TypeConfig.panel.block(),
                Style: TotalsShipping.TypeConfig.panel.style(),
                Description: TotalsShipping.TypeConfig.panel.description(),
                Label: TotalsShipping.TypeConfig.panel.label(),
                Value: TotalsShipping.TypeConfig.panel.value(data)
            },
            display: 'Shipping',
            group,
            image: ''
        },
        {
            id: 'grandTotal',
            component: TotalsGrandTotal.Component,
            config: {
                Block: TotalsGrandTotal.TypeConfig.panel.block(),
                Style: TotalsGrandTotal.TypeConfig.panel.style(),
                Description: TotalsGrandTotal.TypeConfig.panel.description(),
                Label: TotalsGrandTotal.TypeConfig.panel.label(),
                Value: TotalsGrandTotal.TypeConfig.panel.value(data)
            },
            display: 'Grand Total',
            group,
            image: ''
        },
        {
            id: Name.Block.Total.Paid,
            component: TotalsPaid.Component,
            config: {
                Block: TotalsPaid.TypeConfig.panel.block(),
                Style: TotalsPaid.TypeConfig.panel.style(),
                Description: TotalsPaid.TypeConfig.panel.description(),
                Label: TotalsPaid.TypeConfig.panel.label(),
                Value: TotalsPaid.TypeConfig.panel.value(data)
            },
            display: 'Total Paid',
            group,
            image: ''
        },
        {
            id: Name.Block.Total.Refunded,
            component: TotalsRefunded.Component,
            config: {
                Block: TotalsRefunded.TypeConfig.panel.block(),
                Style: TotalsRefunded.TypeConfig.panel.style(),
                Description: TotalsRefunded.TypeConfig.panel.description(),
                Label: TotalsRefunded.TypeConfig.panel.label(),
                Value: TotalsRefunded.TypeConfig.panel.value(data)
            },
            display: 'Total Refunded',
            group,
            image: ''
        },
        {
            id: Name.Block.Total.Balance,
            component: TotalsBalance.Component,
            config: {
                Block: TotalsBalance.TypeConfig.panel.block(),
                Style: TotalsBalance.TypeConfig.panel.style(),
                Description: TotalsBalance.TypeConfig.panel.description(),
                Label: TotalsBalance.TypeConfig.panel.label(),
                Value: TotalsBalance.TypeConfig.panel.value(data)
            },
            display: 'Balance',
            group,
            image: ''
        }
    ]
};
const Content = {
    [Name.Block.Inventory.List]: LineItemCellBlocks,
    [Name.Block.PaymentCredit.CreditsContainer]: PaymentCreditCellBlocks,
    [Name.Block.PaymentCredit.PaymentsContainer]: PaymentCreditCellBlocks
};
const Tokens = {
    get: (id, data) => {
        switch (id) {
            case Name.Block.Client.ContactMeta:
                return ContactMeta.Tokens();
            case Name.Block.Company.StaffName:
                return MetaStaff.Tokens();
            case Name.Block.Date:
                return MetaDate.Tokens();
            case Name.Block.Inventory.Meta:
                return LineItemCellMetaTokens(data);
            case Name.Block.PaymentCredit.Amount:
            case Name.Block.PaymentCredit.Date:
            case Name.Block.PaymentCredit.Method:
                return PaymentCreditCellMetaTokens(data);
            case Name.Block.Notes:
                return MetaNotes.Tokens();
            case Name.Block.Number:
                return MetaNumber.Tokens(Name.Config.Invoice);
            case Name.Block.Total.Balance:
                return TotalsBalance.Tokens(data);
            case Name.Block.Total.Discount:
                return TotalsDiscount.Tokens(data);
            case Name.Block.Total.GrandTotal:
                return TotalsGrandTotal.Tokens(data);
            case Name.Block.Total.Paid:
                return TotalsPaid.Tokens(data);
            case Name.Block.Total.PromoCodes:
                return TotalsPromoCodes.Tokens(data);
            case Name.Block.Total.Refunded:
                return TotalsRefunded.Tokens(data);
            case Name.Block.Total.Shipping:
                return TotalsShipping.Tokens(data);
            case Name.Block.Total.Subtotal:
                return TotalsSubtotal.Tokens(data);
            case Name.Block.Total.Taxes:
                return TotalsTaxes.Tokens(data);
        }
    }
};

export {
    Blocks,
    Content,
    Tokens
}